export default "__VITE_ASSET__B7faT_hn__"